/**
 * @module builder
 */
import type { QuoteDocument, OptionsDocument } from 'paintscout'

import type { QuoteItemSection, UpdateableItem } from '../../types'

import { getArea } from '../../areas/get-area/get-area'
import { getLineItem } from '../../line-items/get-line-item/get-line-item'
import { getSubstrate } from '../../substrates/get-substrate/get-substrate'
import { getGroup } from '../../groups/get-group/get-group'

export function findItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  section?: QuoteItemSection
}): UpdateableItem {
  const { quote, key } = args
  if (quote.areas[key]) {
    return getArea({ ...args, key })
  } else if (quote.lineItems[key]) {
    return getLineItem({ ...args, key })
  } else if (quote.substrates[key]) {
    return getSubstrate({ ...args, key })
  } else if (quote.groups[key]) {
    return getGroup({ ...args, key })
  }
  return null
}
